export default __webpack_public_path__ + "static/media/PrincipeOpen.b010c08f.jpg";